// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"dbf65109","191":"69e961d4","408":"708d749d","505":"f7ae6288","541":"eef6b4b8","617":"27ce81a7"}[chunkId] + ".chunk.js";
};